export default __webpack_public_path__ + "static/media/H1009.4057bc6f.mp3";